import { Template } from "./template.js";
import { Left_menu } from './left_menu/component.js'
import { Info_window } from './info_window/component.js'

const Page1_tubes = {
	name: 'Page1_tubes',
	components: {
		'left-menu': Left_menu,
		'info-window': Info_window
	},
	template: Template,
	data: function() {
		return {
			tubes: [], // массив труб
			intervalID: null, // Индикатор таймера для аякса
			map: null,
			selectedTube: null
		}
	},
	computed: {
		tubesComputed() {
			return this.tubes
		},
		infoClass() {
			return this.selectedTube ? "show-info" : "full-map";
		}
	},
	
	created() {
		var cont = this;
		// Первый запуск - рисуем карту
		this.getTubes(true);

		// при загрузке запускаем периодический аякс
		this.intervalID = setInterval(this.getTubes, globalConstants.tubeRefreshInterval)
	},
	beforeDestroy() {
		// при выходе - убиваем таймер аякса
		clearInterval(this.intervalID);
	},
	mounted() {

	},

	methods: {
		tubeClick(tube) {
			var cont = this;
			if (this.selectedTube) {
				this.selectedTube.layer.setStyle(this.selectedTube.layer.originalStyle);
			}
			this.selectedTube = tube; // info_window увидит это, и отрисует график

			this.selectedTube.layer.setStyle({ color: "#0000ff" });

			var tId = setInterval(function() {
				cont.map.invalidateSize() //пересчитать размер во время раскрытия окна
			}, 20);

			setTimeout(function() {
				clearInterval(tId); //останавливаем пересчет
				//перелетаем к слою
//				cont.map.flyTo(tube.layer.getBounds().getCenter(), 17, {
//					animate: true,
//					duration: 1.5
//				})
				cont.map.flyTo([JSON.parse(tube.tubeData.marker).coordinates[1],JSON.parse(tube.tubeData.marker).coordinates[0]], 17, {
					animate: true,
					duration: 1.5
				})
				//рисуем график




			}, 550);


		},
		paintHeat() { //временное решение для демонстрации
			var cont = this;
			console.log('heatmap');
			var heat = L.heatLayer([
				[
					53.91297454740858,
					27.5777,
					1
				],
				[
					53.9132,
					27.5777,
					1
				],
				[
					53.9131,
					27.5777,
					1
				],
				[
					53.9131,
					27.5775,
					1
				],
				[
					53.91312937310582,
					27.57738947868347,

					0.5
				],
				[
					53.91297454740858,
					27.577480673789978,

					0.7
				],
				[
					53.9142,
					27.57738947868347,
					0.6
				],
				[
					53.9141,
					27.57738947868347,
					0.3
				],
				[
					53.9140,
					27.57738947868347,
					0.2
				],
				[
					53.9142,
					27.5771,
					0.6
				],
				[
					53.9141,
					27.5771,
					0.6
				],
				[
					53.9139,
					27.5786,
					0.4
				],
				[
					53.9139,
					27.5788,
					0.4
				],
				[
					53.9140,
					27.5789,
					0.4
				]

			], { radius: 30, blur: 30 }).addTo(cont.map);


		},
		getTubes(firstRun) {
			//console.log('get tube data');
			var cont = this;
			//запускаем аякс из плагина
			this.$API('static_data', 'tubes', {},
				function(data) {
					if (firstRun) { // если превый запуск - рисуем карту
						//сама карта
						cont.map = L.map('mapid').setView(globalConstants.initialCoordinates, 13);
						// по нажатию скрываем инфоокно и убираем выделение линий
						cont.map.on('click', function() { //скрываем инфоокно
							if (cont.selectedTube) { //возвращаем стиль
								cont.selectedTube.layer.setStyle(cont.selectedTube.layer.originalStyle);
							}
							cont.selectedTube = null // ничего не выбрано, заодно график удалится
							//пересчитать размер во время раскрытия окна, костыль для лефалета
							var tId = setInterval(function() {
								cont.map.invalidateSize()
							}, 20);
							setTimeout(function() {
								clearInterval(tId); //останавливаем пересчет
							}, 550);
						});
						//добавляем подложку
						cont.map.baseLayer = L.tileLayer('https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg', {
							attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery © <a href="https://www.mapbox.com/">Mapbox</a>',
							maxZoom: 18,
							id: 'mapbox/streets-v11',
							accessToken: 'pk.eyJ1IjoiZGFyeWFjaHlydWsiLCJhIjoiY2swbzEwNnlrMDViYzNrcXI4NDAyN2gyNiJ9.d5mwHr6_wkJRtV0aXZv7Mg'
						}).addTo(cont.map);

						// рисуем подложку тепловизора, временное решение
						cont.paintHeat();

					}

					//прогоняем массив, вернувшийся по апи
					data.some(function(el) {
						var newElement = {
							tubeData: el //выделяем данные в отдельное свойство нового элементы, чтобы за раз проверить не подмешивая свойства Vue
						};
						// найдем индекс элемента по имени трубы
						var checkElementIndex = cont.tubes.findIndex(element => element.tubeData.tube_name == newElement.tubeData.tube_name);
						if (checkElementIndex == -1) // если нет такого элемента
						{
							var owtv = "";
							var owpv = "";
							if (newElement.tubeData.onewire_t && newElement.tubeData.onewire_t.length)
							{
								var owt = JSON.parse(newElement.tubeData.onewire_t);
								owtv = owt[0];
								if (owtv < -100) owtv = "";
//								console.log(owt);
//								console.log(owt[0]);
//								console.log(owtv);
							}
//							console.log(owtv);
							if (newElement.tubeData.onewire_p && newElement.tubeData.onewire_p.length)
							{
								var owp = JSON.parse(newElement.tubeData.onewire_p);
								owpv = owp[0] / globalConstants.pressureUnits[globalConstants.pressureUnitIndex].ratio;
								owpv = owpv.toFixed(3);
//								console.log(owp);
//								console.log(owp[0]);
//								console.log(owpv);
							}
//							console.log(owpv);
							// координаты линии и маркера берем из АПИ
							var layerGeometry = [JSON.parse(newElement.tubeData.coordinates),
								JSON.parse(newElement.tubeData.marker)
							];
							// свет от состояния изоляции и провода
							var color = cont.$getColorTemp(newElement.tubeData.isol);
							var style = { 'color': color };
							// добавляем ссылку на слой в элемент и сразу слой на карту
							newElement.layer = L.geoJSON(layerGeometry, {
								style: style
							}).addTo(cont.map);
							// сохраяем этот стиль
							newElement.layer.originalStyle = style;
							// содержимое маркера
							var html = "<DIV class='marker-shape' style='border-color:" + color + "' title='" +
								+newElement.tubeData.full_serial + "'>" +
								(newElement.tubeData.isol == "0" ? "🚫︎&nbsp;" : "") + //отрисуем символ, если проблемы с изоляцией
								(newElement.tubeData.wire == "0" ? "⚡︎&nbsp;" : "") + //отрисуем символ, если проблемы с проводом
								(newElement.tubeData.too_old ? "⏰&nbsp;" : "") + //отрисуем символ, если показания старые
								newElement.tubeData.tube_name + " " + owtv +
								(owtv == "" ? "" : "℃") +
								owpv +
								(owpv == "" ? "" : globalConstants.pressureUnits[globalConstants.pressureUnitIndex].unit) +
//								((!newElement.tubeData.too_old) &&
//									this.selected.tubeData.onewire_t.length &&
//									Array.isArray(JSON.parse(this.selected.tubeData.onewire_t)) ? JSON.parse(newElement.tubeData.onewire_t)[0] : "") +
								"</div>";
							// а теперь проверяем слой, первый элемент - линия, второй - точка, точке меняем контент маркера
							newElement.layer.eachLayer(function(layer) {
								if (layer.feature.geometry.type == 'Point') {
									layer.setIcon(new L.DivIcon({
										className: 'station-marker',
										html: html
									}))
								}
							});
							// и обратную ссылку, чтобы можно было по слою найти данные
							newElement.layer.linkToData = newElement;
							//клик на слой - тоже самое, тчо клик в таблице
							newElement.layer.on('click', function(e) {
								L.DomEvent.stopPropagation(e); // нам не нужно, чтобы отработал клик на карет
								cont.tubeClick(this.linkToData);

							});
							cont.tubes.push(newElement); //добавим в массив труб
							//если данные в АПИ отличаются от сохраненных данных, то перерисовываем все подряд
						} else if (JSON.stringify(cont.tubes[checkElementIndex].tubeData) != JSON.stringify(newElement.tubeData)) //или данные в нем поменялись
						{
							console.log('tube data updated', newElement.tubeData)
							cont.tubes[checkElementIndex].layer.clearLayers(); // чистим геометрию
							//перезаписываем ее// координаты линии и маркера
							var layerGeometry = [JSON.parse(newElement.tubeData.coordinates),
								JSON.parse(newElement.tubeData.marker)
							];
							cont.tubes[checkElementIndex].layer.addData(layerGeometry);
							//меняем цвет
							var color = cont.$getColorTemp(newElement.tubeData.isol);
							var style = { 'color': color };
							cont.tubes[checkElementIndex].layer.setStyle(style);
							//							newElement.layer.originalStyle = style;
							var html = "<DIV class='marker-shape' style='border-color:" + color + "' title='" +
								+newElement.tubeData.serial + "'>" +
								(newElement.tubeData.wire == "0" ? "🚫&nbsp;" : "") +
								newElement.tubeData.tube_name + "</div>";
							cont.tubes[checkElementIndex].layer.eachLayer(function(layer) {
								if (layer.feature.geometry.type == 'Point') {
									layer.setIcon(new L.DivIcon({
										className: 'station-marker',
										html: html
									}))
								}
							});
							cont.tubes[checkElementIndex].tubeData = newElement.tubeData;
						}

					});

				},
				function(errorText) { console.log(errorText) });

		}

	}


}

export { Page1_tubes }


// WEBPACK FOOTER //
// ./src/app/js/components/page1_tubes/component.js